import React from "react";
import { Box, Container, Typography } from "@mui/material";
import FormBuilder3 from "../components/FormBuilder3";
import Header from "../components/Header";
import SAB from "../assets/SAB-survey.json";
function SABsurvey() {
  return (
    <Box
      sx={{
        background: "#263859",
      }}
    >
      {/* <Particle /> */}
      <Header />
      <Container maxWidth="md" sx={{ marginTop: "2rem"}}>
        <Typography
          variant="h4"
          sx={{ textAlign: "center", marginBottom: "2rem", color: "#fff" }}
        >
          SAB Survey
        </Typography>
        {/* <FormBuilder2 /> */}
        <FormBuilder3 questions={SAB} />
      </Container>
    </Box>
  );
}

export default SABsurvey;
